
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import { ITicketProps } from '../../../../../../types/Ticket/ITicket';
import { UserApi } from '../../../../../../redux/api/UserApi';
import { useReduxDispatch, useReduxSelector } from '../../../../../../redux/hooks';
import { SetSelectedActions } from '../../../../../../slices/SelectedActionsSlice';

const SplitButton: React.FC<ITicketProps> = (ticket) => {
    const selectedActions = useReduxSelector(state => state.selectedActionsStore.selectedActions);
    const thisTicketActionsSelected = selectedActions?.filter(a => a.ticketId === ticket.ID);
    const dispatch = useReduxDispatch();
    const navigate = useNavigate();
    const { data: userProfile } = UserApi.useGetUserProfileQuery();


    const splitButtonClicked = (e) => {
        if (!thisTicketActionsSelected || thisTicketActionsSelected?.length === 0) {
            if (thisTicketActionsSelected?.length === 0) { window.alert(`Select 1 or more ${userProfile?.Phrases.Action}s to Split`) }

            //Show the option to selected actions
            dispatch(SetSelectedActions([]));
            return;
        }

        //splitActionIds=${thisTicketActionsSelected?.map(s => s.actionId.toString()).join(',') || ""}
        navigate(`/ticket/new/details?splitTicketId=${ticket?.ID || ""}&endUserId=${ticket?.Contact?.UId || ""}`)
    };

    return (
        <Button disabled={ticket.Is_Loading} className='related-button' onClick={splitButtonClicked} title={`Split into new ${userProfile?.Phrases.CallPhrase}`} imageUrl='./images/Toolbar/split.png'
            size='large' ></Button>
    );
};

export default SplitButton;

